export { default as CoreMarqueeItemComponent } from './MarqueeItem';
